<template>
  <dialog-form
    :value="value"
    @input="$emit('input', $event)"
    :title="$localize('DeleteProduct.title')"
    action="delete"
    @commit="save"
  >{{ $localize('DeleteProduct.description') }}</dialog-form>
</template>

<script>
import DialogForm from "@/shared/components/DialogForm";

import sendCommand from "@/services/sendCommand";
import { isGuid } from "@/services/validation"

export default {
  components: { DialogForm },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    savedProductId: {
      validator: isGuid,
      required: true
    }
  },

  methods: {
    async save(callback) {
      const result = await sendCommand("DeleteSavedProduct", {
        savedProductId: this.savedProductId
      });
      if (result.success) {
        this.$emit("saved");
      } 

      callback({success: result.success})
    }
  }
};
</script>